import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function minValue(minValue: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    try {
      const value = Number(control.value);
      console.log(value, "validator");
      if (isNaN(value)) return { minValue: { value: control.value } };
      else if (value < minValue) return { minValue: { value: control.value } };
      else return null;
    } catch (e) {
      return null;
    }
  };
}
